/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-require-imports */
const path = require('path');

/** @type {import('next-i18next').UserConfig} */
module.exports = {
  // https://www.i18next.com/overview/configuration-options
  i18n: {
    defaultLocale: 'en',
    locales: ['en', 'en-CA', 'fr', 'fr-CA', 'es'],
    localeDetection: false,
  },
  /** To avoid issues when deploying to some paas (vercel...) */
  localePath:
    typeof window === 'undefined'
      ? path.resolve('./public/locales')
      : '/locales',
  debug: process.env.NODE_ENV === 'development',
  saveMissing: process.env.NODE_ENV === 'development',
  saveMissingTo: 'all',
  returnNull: false,
  returnEmptyString: false,
  returnObjects: true,
  load: 'all',
  serializeConfig: false,
};